import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import {
  isToastDisabledForDebug,
  showToast,
} from '#/zustand-stores/toastsStore';

export type InviteAcceptedLocationState = {
  shouldDisplayInviteAcceptedToast?: boolean;
  organizationName?: string;
};

function InviteAcceptedToastContainerClientSide() {
  const { i18n } = useI18n();
  const location = useLocation<InviteAcceptedLocationState>();

  useEffect(() => {
    if (!location.state?.shouldDisplayInviteAcceptedToast) return;

    showToast({
      id: 'invite-accepted-toast',
      variant: 'success',
      icon: 'success',
      headline: i18n('Invite accepted'),
      body: location.state.organizationName
        ? i18n(
            "You've been successfully added as a contact to {{strong}}%(organizationName)s{{/strong}}.",
            {
              organizationName: location.state.organizationName,
              strong: <strong />,
            },
          )
        : i18n("You've been successfully added as a contact."),
      dismissible: true,
    });
  }, [i18n, location.state]);

  return null;
}

export function InviteAcceptedToastContainer() {
  if (isToastDisabledForDebug('invite-accepted-toast')) return null;

  return <InviteAcceptedToastContainerClientSide />;
}
